import { isEmpty } from 'lodash';
import React, { Fragment } from 'react';

import {
  ADD_FUND_MODAL_PROPS,
  ExchangeType,
} from '../../../../settings/settings';
import { hasOnlyRetirementFunds } from '../../../../utils/funds/funds-utility';
import { isRolloverOrTraditionalIRA } from '../../../../utils/funds/shared/shared-fund-notes-utility';
import { getFundByAgreementId } from '../../../../utils/shoppingCart/shopping-cart-utility';
import {
  isAppBuy,
  isAppSell,
  isBuy,
  isCollegeExchange,
  isExchange,
  isSell,
  isCollegeContribute,
  isCollegeDistribute,
} from '../../../../utils/transactions-util';
import { coalesce, hasValue } from '../../../../utils/utils';
import FastEqualComponent from '../../../FastEqualComponent/FastEqualComponent';
import FundListActionBar from '../../BuyLanding/FundListActionBar';
import IRAMaxAction from '../IRAMaxAction/IRAMaxAction';
import ShowMoreAccounts from '../ShowMoreAccounts/ShowMoreAccounts';
import ConvertIRAActionBar from './ConvertIRAActionBar';
import ExpandedFund from './ExpandedFund';
import ExpandedFundGroupHeader from './ExpandedFundGroupHeader';
import './ExpandedFundList.scss';
import { setShowAllNasuFunds } from '../../../../redux/modules/nasuAddedFunds/nasuAddedFunds.module';

class ExpandedFundList extends FastEqualComponent {
  constructor(props) {
    super(props);
    const {
      actions: { selectFund },
      availableFunds: funds,
    } = props;

    this.showClick = this.showClick.bind(this);
    if (funds.length === 1) {
      const { agreementID, BPID, disabled, selected } = funds[0];
      if (!disabled && !selected) {
        selectFund(agreementID, funds[0], BPID);
      }
    }
  }

  showClick() {
    const {
      actions: { setShowAllFundsStep },
      setShowAllSellFunds,
    } = this.props;
    if (isBuy() || isExchange() || isAppBuy()) {
      setShowAllFundsStep(true);
    } else if (isSell() || isAppSell()) {
      setShowAllSellFunds(true);
    }
  }

  render() {
    const {
      customerWebViewEnabled,
      isSalesforceRep,
      actions,
      availableFunds,
      canAddNewFund,
      currentYearInclusiveRemainingContributions,
      currentStep,
      deliveryMethod,
      displayTradeDate,
      eligibleForRMD,
      exchangeType,
      exchangeFromFunds,
      exchangeFromTotalDollars,
      fundBannerNote,
      fromFundTotalAmount,
      fundEditor,
      fundGroupHeader: FundGroupHeader = ExpandedFundGroupHeader,
      fundListActionBarLink,
      fundListActionBarModalProps = ADD_FUND_MODAL_PROPS.DEFAULT,
      hasAPP,
      hasAtleastOneFullyContributedIRA,
      hasExchangeFromSweep,
      hasNotInheritedSEPOrSimpleIRA,
      householdBalanceTierStatus,
      iClassFundLookUp,
      IRADataLookUp,
      IRALimit,
      isCorporateAccountType,
      isFullyContributedIRA,
      isManySelect,
      isQuickSellWithoutZeroBalance,
      nonRetirementMaxLimit,
      numberOfFunds,
      personalData,
      priorYearInclusiveRemainingContributions,
      quickBuy: { showAllFundsStep },
      quickSellAgreementID,
      RMData,
      selectedFund,
      showAddNewFundOrAccount,
      showAddNewFundOrAccountEvenIfEmpty = false,
      showAllSellFunds,
      transactionLimit,
      userAddress,
      userFunds,
      userRegistrationTypeInfo,
      windowCutoffDate,
      eligibleFromFundForExchangeToNew,
      systematicActivityRMDs,
      ...passthrough
    } = this.props;
    if (isBuy() || isExchange()) {
      setShowAllNasuFunds(true);
    }
    if (isEmpty(availableFunds) && !showAddNewFundOrAccountEvenIfEmpty) {
      return null;
    }
    const fundIsRolloverOrTraditionalIRA =
      selectedFund && isRolloverOrTraditionalIRA(selectedFund);
    const quickBuyAgreementId = getFundByAgreementId();
    const isQuickBuyRetirementFund =
      quickBuyAgreementId === null ||
      (quickBuyAgreementId !== null &&
        hasValue(availableFunds) &&
        quickBuyAgreementId === availableFunds[0].agreementID &&
        availableFunds[0].displayClassification === 'RETIREMENT') ||
      showAllFundsStep;

    const displayShowMoreAccounts =
      isBuy() || isAppBuy()
        ? quickBuyAgreementId && !showAllFundsStep && numberOfFunds > 1
        : isSell()
        ? quickSellAgreementID &&
          !showAllSellFunds &&
          numberOfFunds > 1 &&
          isQuickSellWithoutZeroBalance
        : quickBuyAgreementId &&
          !showAllFundsStep &&
          exchangeType === ExchangeType.MANY_TO_ONE;
    const showIRAMaxAction =
      (isBuy() || isAppBuy()) &&
      hasAtleastOneFullyContributedIRA &&
      !isCorporateAccountType &&
      isQuickBuyRetirementFund;
    return (
      <div className="e2e-expanded-fund-list expanded-fund-list">
        {showIRAMaxAction && (
          <IRAMaxAction
            isSalesforceRep={isSalesforceRep}
            customerWebViewEnabled={customerWebViewEnabled}
            IRADataLookUp={IRADataLookUp}
            IRALimit={IRALimit}
            actions={actions}
            hasOnlyRetirementFunds={hasOnlyRetirementFunds(userFunds)}
            modalProps={fundListActionBarModalProps}
            quickBuyAgreementId={quickBuyAgreementId}
            showAllFundsStep={showAllFundsStep}
          />
        )}
        {availableFunds.map((fund, i) => {
          if (fund === undefined) {
            return null;
          }
          const isQuickBuyAgreementId =
            quickBuyAgreementId !== null &&
            quickBuyAgreementId === fund.agreementID;
          return (
            <Fragment key={fund.agreementID}>
              <FundGroupHeader
                fund={fund}
                lastFund={coalesce(availableFunds[i - 1], {})}
              />
              <ExpandedFund
                {...passthrough}
                customerWebViewEnabled={customerWebViewEnabled}
                isSalesforceRep={isSalesforceRep}
                fundEditor={fundEditor && fundEditor(fund)}
                fundIndex={i}
                systematicActivityRMDs={systematicActivityRMDs}
                fundType={exchangeType}
                currentStep={currentStep}
                fromFundTotalAmount={fromFundTotalAmount}
                hasExchangeFromSweep={hasExchangeFromSweep}
                iClassVersion={
                  iClassFundLookUp && iClassFundLookUp[fund.agreementID]
                }
                {...{
                  actions,
                  availableFunds,
                  currentYearInclusiveRemainingContributions,
                  currentStep,
                  deliveryMethod,
                  displayTradeDate,
                  eligibleForRMD,
                  exchangeType,
                  exchangeFromFunds,
                  exchangeFromTotalDollars,
                  fund,
                  fundBannerNote,
                  hasAPP,
                  hasNotInheritedSEPOrSimpleIRA,
                  householdBalanceTierStatus,
                  IRALimit,
                  isFullyContributedIRA,
                  isManySelect,
                  isQuickBuyAgreementId,
                  nonRetirementMaxLimit,
                  personalData,
                  priorYearInclusiveRemainingContributions,
                  RMData,
                  selectedFund,
                  transactionLimit,
                  userAddress,
                  userFunds,
                  windowCutoffDate,
                  systematicActivityRMDs,
                }}
              />
            </Fragment>
          );
        })}
        {displayShowMoreAccounts ? (
          <ShowMoreAccounts
            numberOfFunds={numberOfFunds}
            onShowClick={this.showClick}
            isCollege={
              isCollegeContribute() ||
              isCollegeDistribute() ||
              isCollegeExchange()
            }
          />
        ) : showAddNewFundOrAccount ? (
          <FundListActionBar
            {...{
              isSalesforceRep,
              customerWebViewEnabled,
              actions,
              canAddNewFund,
              fundListActionBarLink,
              modalProps: fundListActionBarModalProps,
              userRegistrationTypeInfo,
              selectedFund,
              exchangeType,
              exchangeFromFunds,
              eligibleFromFundForExchangeToNew,
            }}
          />
        ) : null}
        {isExchange() &&
          fundIsRolloverOrTraditionalIRA &&
          !(!customerWebViewEnabled && isSalesforceRep) && (
            <ConvertIRAActionBar />
          )}
      </div>
    );
  }
}

export default ExpandedFundList;
